import { Injectable } from "@angular/core";
import { AbstractControl, AsyncValidator, ValidationErrors } from "@angular/forms";
import { Observable, of } from "rxjs";
import { debounceTime, distinctUntilChanged, filter, map, switchMap, take } from "rxjs/operators";

import { AppGlobals } from "@app/app.global";
import { AuthService, User } from "@app/core";

@Injectable({ providedIn: 'root' })
export class UniqueEmailValidator implements AsyncValidator {
    user: User;

    constructor(private authService: AuthService,
        private appGlobals: AppGlobals) { }

    validate(control: AbstractControl): Observable<ValidationErrors | null> {
        if (!control.valueChanges || control.pristine) {
            return of(null);
        }

        return control.valueChanges.pipe(
            filter(email => email.length >= this.appGlobals.minAsyncSearchCharacter &&
                this.user?.email !== email),
            debounceTime(this.appGlobals.defaultDebounceTime),
            distinctUntilChanged(),
            switchMap(email => this.authService.isEmailExists(email)),
            map(res => (res.exists ? { uniqueEmail: true } : null)),
            take(1)
        );
    }
}